"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _CampaignsError = _interopRequireDefault(require("./CampaignsError"));

var _Campaigns = _interopRequireDefault(require("./Campaigns"));

require("../styles/_recent-campaigns.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RecentCampaigns = /*#__PURE__*/function (_Component) {
  _inherits(RecentCampaigns, _Component);

  function RecentCampaigns() {
    var _this;

    _classCallCheck(this, RecentCampaigns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecentCampaigns).call(this));

    _defineProperty(_assertThisInitialized(_this), "fetchCampaigns", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getCampaigns, apolloClient, organisationId, _ref2, data, error, _data$getCampaigns, count, campaigns, campaignsWithImages;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getCampaigns = _this$props.getCampaigns, apolloClient = _this$props.apolloClient, organisationId = _this$props.organisationId;
              _context.next = 3;
              return getCampaigns({
                limit: 5,
                offset: 0
              });

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(error || !data || !data.getCampaigns)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                fetchError: true
              }));

            case 8:
              _data$getCampaigns = data.getCampaigns, count = _data$getCampaigns.count, campaigns = _data$getCampaigns.campaigns;
              _context.prev = 9;
              _context.next = 12;
              return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: campaigns,
                substitutedKeys: ['coverImageKey'],
                organisationId: organisationId
              });

            case 12:
              campaignsWithImages = _context.sent;

              _this.setState({
                campaigns: campaignsWithImages,
                count: count,
                fetchError: false
              });

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);

              _this.setState({
                fetchError: true
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "goToManageCampaigns", function () {
      var history = _this.props.history;
      history.push('/manage/campaigns');
    });

    _this.state = {
      fetchError: false
    };
    return _this;
  }

  _createClass(RecentCampaigns, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchCampaigns();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          campaigns = _this$state.campaigns,
          fetchError = _this$state.fetchError,
          count = _this$state.count;
      var history = this.props.history;
      return _react.default.createElement("div", {
        className: "recent-campaigns"
      }, _react.default.createElement("div", {
        className: "recent-campaigns__header"
      }, _react.default.createElement("h3", null, "Recent Campaigns"), campaigns || fetchError ? _react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: this.goToManageCampaigns
      }, campaigns && campaigns.length ? "VIEW ALL CAMPAIGNS ".concat(count ? "(".concat(count, ")") : '') : 'NEW CAMPAIGN') : null), fetchError ? _react.default.createElement(_CampaignsError.default, {
        message: "Something went wrong fetching your recent campaigns.",
        onRefetch: this.fetchCampaigns
      }) : _react.default.createElement(_Campaigns.default, {
        campaigns: campaigns,
        history: history
      }));
    }
  }]);

  return RecentCampaigns;
}(_react.Component);

var _default = (0, _commonReact.requiresPermission)({
  ComponentToRender: RecentCampaigns,
  requiredPermission: 'MANAGE_INSPIRATION_CAMPAIGNS',
  isRoute: true
});

exports.default = _default;